<template>
  <div class="card-form">
    <page-main
      ref="main"
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @checkboxChange="checkboxChange"
    >
      <page-header
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
        @exportFile="exportFile"
      />
      <template #toolbar_btn>
        <SortFieldsPopover
          v-model="sortFields"
          funcListName="awsReportSkuInvList"
          style="margin-right: 0.8em;"
          @change="reload"
        />
      </template>
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>
    <chooseTemplate
      @confirmClose="clearCheckList"
      :visible.sync="chooseTemplateOptions.visible"
      :templateQueryParams="{
        templateGroup: chooseTemplateOptions.templateGroup,
      }"
      :exportOptions="{
        params: { searchForm: chooseTemplateOptions.searchForm },
      }"
    />
  </div>
</template>
<script>
import PageHeader from './header'
import PageMain from './main.vue'
import BaseTable from '@/mixins/base-table'
import chooseTemplate from '@/views/ecom/components/choose-template'
import SortFieldsPopover from '@/views/ecom/components/sort-fields-popover'
export default {
  mixins: [BaseTable],
  components: { PageMain, PageHeader, chooseTemplate, SortFieldsPopover },
  data() {
    return {
      usePage: true,
      chooseTemplateOptions: {
        visible: false,
        templateGroup: 'ecom-skuDomesticStock',
        searchForm: {},
      },
      checkList: [],
      sortFields: [],
    }
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .ecomecomAmzSkuInvFtyListApi({
          ...form,
          ...this.page,
          sortFields: this.sortFields,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    clearCheckList() {
      this.$refs.main.removeCheckboxRow()
      this.checkList = []
    },
    exportFile(form) {
      this.chooseTemplateOptions.visible = true
      this.chooseTemplateOptions.searchForm = form || {}
      this.chooseTemplateOptions.searchForm.checkList = this.checkList
    },
    checkboxChange(data) {
      const tmp = data?.map((e) => e.amzSkuCode || '') || []
      this.checkList = tmp.filter((e) => Boolean(e))
    },
  },
}
</script>
